import { MAIN_STYLE, MAIN_STYLE_GROUPS, PRESS_EVENTS } from '../shared.js'
export const obj = {

    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                keep_circle: { type: 'bool', internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        // ATTR_SWIPE dispatches to attribute_common_tag (hasp_attribute.cpp:2759-2760), storing
        // an arbitrary string tag (hasp_object.h:28) — not an on/off flag, same bug as btn.js.
        swipe:    { type: 'string' },
        groupid:  { type: 'int', min: 0, max: 15, exportSpecial: true },
        entityid: { type: 'string', internal: true },
        stretch_mode: {
            type: 'string', internal: true, default: 'full',
            options: ['none', 'v_stretch', 'h_stretch', 'full'],
        },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, min_width: 40, min_height: 10,
            enabled: true, hidden: false,
        },
        styles: {
            // Real LV_THEME_OBJ defaults (lv_theme_hasp.c: styles->pretty, lines 249-282). Only
            // static numeric literals captured — bg_color/border_color/text_color are
            // theme-computed, not single firmware constants. Every bundled theme
            // (hasp-dark/light, material-dark/light, mono) already overrides all of main's
            // MAIN_STYLE properties including radius, so this fallback has no visible effect on
            // any currently themed obj — verified via StyleResolver's cascade (schema default <
            // theme < local < state) and every bundled themes/*/obj.js.
            main: {
                radius: 10,      // LV_DPI / 15 = 160 / 15 (integer division), lv_theme_hasp.c:251
                bg_opa: 255,     // LV_OPA_COVER, lv_theme_hasp.c:256
                border_width: 2, // BORDER_WIDTH = HASP_DPX(2), lv_theme_hasp.c:81,272
            },
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu'],
    runtimeCapabilities: ['has_action', 'has_group'],

    events: PRESS_EVENTS,

    bindings: {
        properties: { bg_color: {}, bg_opa: {}, border_color: {}, border_width: {},
            radius: {}, shadow_width: {}, shadow_color: {}, shadow_ofs_x: {}, shadow_ofs_y: {},
            outline_width: {}, outline_color: {}, outline_pad: {}, },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'scene', 'esphome'] },
    },
}
